<template>
  <el-dialog
    :title="text.joinBulkTitle"
    :visible="visible"
    width="640px"
    @update:visible="$emit('update:visible', $event)">
    <p class="join-bulk__summary">{{ text.joinBulkRequested }} {{ summary.requested }}건</p>

    <el-table :data="summary.groups" size="mini" border :empty-text="text.storeEmpty">
      <el-table-column :label="$t('구분')" width="120">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.tagType">{{ scope.row.label }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('건수')" width="80" align="right" prop="count"></el-table-column>
      <el-table-column :label="$t('매장')" min-width="300">
        <template slot-scope="scope">
          <!-- 조건 미달은 **사유가 매장마다 다르다** — 건수만 말하면 무엇을 고쳐야 할지 알 수 없다 -->
          <template v-if="scope.row.rows">
            <div v-for="row in scope.row.rows" :key="row.storeCd" class="join-bulk__row">
              {{ row.storeCd }} — {{ row.reasonsText }}
            </div>
          </template>
          <template v-else>{{ scope.row.storeCds.join(', ') || '-' }}</template>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer">
      <el-button size="small" type="primary" @click="$emit('update:visible', false)">{{ text.closeAction }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { CALLPOP_TEXT } from '@/utils/callpopText'

/**
 * 일괄 참여 등록의 결과 표 — **전부-아니면-전무가 아니다**(§3-9).
 *
 * 네 갈래(등록·이미 참여 중·조건 미달·찾을 수 없음)에 범위 밖 건수가 더해진다. 건수가 0인 갈래는
 * 아예 그리지 않는다(집계는 순수 함수 `callpopOrg.joinBulkSummary` 가 한다 — 여러 묶음으로 나눠 보낸
 * 응답을 합치는 것도 그 함수다).
 */
export default {
  name: 'StoreJoinBulkResult',

  props: {
    visible: { type: Boolean, default: false },
    /** `callpopOrg.joinBulkSummary` 의 결과 */
    summary: { type: Object, default: () => ({ requested: 0, groups: [] }) },
  },

  data() {
    return { text: CALLPOP_TEXT }
  },
}
</script>

<style scoped>
.join-bulk__summary {
  color: #606266;
  font-size: 13px;
  margin: 0 0 8px;
}
.join-bulk__row {
  line-height: 1.8;
}
</style>
